app.service('productAvailabilityShopMap', function(localStorage) {
	var $self, $mapContent, $mapInfo;
	var map;
	var markers = [];

	function init() {
		setElements();
		initMap();
	}

	function hideInfo() {
		$mapInfo.hide();
	}

	function showInfo() {
		$mapInfo.show();
	}

	function setElements() {
		$self = $('.shops-map');
		$mapContent = $('.shops-map-canvas', $self);
		$mapInfo = $('.shops-map-info', $self);
	}

	function initMap() {
		if (!$mapContent.length) return;

		$(window).on('orientationchange load', function(event) {
			resize();
		});
		map = new google.maps.Map($mapContent.get(0), {
			zoom: 6,
			center: { lng: 19.134, lat: 51.918 },
			streetViewControl: false,
			mapTypeControl: false
		});
	}

	var locations;
	var bounds;

	function setLocations(html) {
		locations = [];
		$('<div>' + html + '</div>')
			.find('li')
			.each(function() {
				locations.push({
					code: $(this).data('shop'),
					name: $(this).data('name'),
					latitude: $(this).data('latitude'),
					longitude: $(this).data('longitude'),
					html: $(this).html()
				});
			});
	}

	function getMessage(shop) {
		let className = '';
		const selectedShopData = JSON.parse(localStorage.getItem('user_shop_data'));

		if (selectedShopData && selectedShopData.shopCode == shop.code) {
			className += ' is-active';
		}

		return `<div class="shop-item js-shop${className}" data-shop="${shop.code}">${shop.html}</div>`;
	}

	function clearMarkers() {
		for (var i = 0; i < markers.length; i++) {
			markers[i].setMap(null);
		}
	}

	function setBoundsAndMarkers() {
		bounds = new google.maps.LatLngBounds();
		$(locations).each(function(i, shop) {
			var latlng = new google.maps.LatLng(shop.latitude, shop.longitude);
			bounds.extend(latlng);
			var marker = new google.maps.Marker({
				position: latlng,
				map: map,
				code: shop.code
			});
			markers.push(marker);

			google.maps.event.addListener(map, 'click', () => {
				hideInfo();
			});

			google.maps.event.addListener(marker, 'click', () => {
				map.panTo(marker.position);

				$mapInfo.html(getMessage(shop)).show();
			});
		});
	}

	function zoom(code) {
		const marker = markers.filter(
			marker => String(marker.code) === String(code)
		)[0];
		const shop = locations.filter(
			shop => String(shop.code) === String(code)
		)[0];

		$mapInfo.html(getMessage(shop)).show();

		const location = marker.getPosition();

		map.panTo(location);
		map.setZoom(16);
	}

	function resize() {
		$mapContent.height($(window).height() / 2);
	}

	function update(html) {
		resize();
		hideInfo();

		bounds = new google.maps.LatLngBounds();

		if (html) {
			setLocations(html);
		}

		clearMarkers();
		setBoundsAndMarkers();

		google.maps.event.trigger(map, 'resize');
		map.setCenter(bounds.getCenter());

		if (locations.length > 1) {
			map.fitBounds(bounds);
		} else {
			map.setZoom(10);
		}
	}

	return {
		init,
		update,
		showInfo,
		hideInfo,
		zoom
	};
});
